import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import TimezoneSelect from "@/shared/components/ui/Select/TimezoneSelect";
import { AlertTriangle, X } from "lucide-react";
import React from "react";

const campaignStartConfirmationModal = ({
  showStartOptionsModal,
  setShowStartOptionsModal,
  startMode,
  setStartMode,
  scheduledDate,
  setScheduledDate,
  scheduledTime,
  setScheduledTime,
  scheduledTimezone,
  setScheduledTimezone,
  handleConfirmStartCampaign,
  domainAuthenticationIssue,
  isLoadingReadiness,
  onCompleteDomainSetup,
}) => {
  return (
    <CustomModal isOpen={showStartOptionsModal} width="540px" className="!p-6">
      <div className="flex flex-col">
        <div className="flex justify-between items-start">
          <div className="flex flex-col">
            <h3 className="text-lg font-semibold text-gray-900">
              Start Campaign
            </h3>
            <p className="text-sm text-gray-500">
              Choose when you want this campaign to start.
            </p>
          </div>
          {/* close button */}
          <button
            className="p-1 hover:bg-gray-100 rounded-full"
            onClick={() => setShowStartOptionsModal(false)}
          >
            <X size={18} color="#181D27" />
          </button>
        </div>

        <div className="flex flex-col gap-3 mt-2">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="campaignStartMode"
              checked={startMode === "now"}
              onChange={() => setStartMode("now")}
            />
            <span className="text-sm text-gray-800">Start now</span>
          </label>

          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="campaignStartMode"
              checked={startMode === "later"}
              onChange={() => setStartMode("later")}
            />
            <span className="text-sm text-gray-800 dark:text-gray-200">Schedule for later</span>
          </label>
        </div>

        <div
          className={`grid grid-cols-1 md:grid-cols-2 gap-3 p-3 rounded-lg border mt-2 ${
            startMode === "later"
              ? "bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-700"
              : "bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-800 opacity-60"
          }`}
        >
          <div className="flex flex-col gap-1">
            <label className="text-xs text-gray-500 dark:text-gray-400">Date</label>
            <input
              type="date"
              value={scheduledDate}
              onChange={(e) => setScheduledDate(e.target.value)}
              disabled={startMode !== "later"}
              className="h-9 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 text-sm text-gray-700 dark:text-gray-200 disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:text-gray-400"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-xs text-gray-500 dark:text-gray-400">Time</label>
            <input
              type="time"
              value={scheduledTime}
              onChange={(e) => setScheduledTime(e.target.value)}
              disabled={startMode !== "later"}
              className="h-9 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 text-sm text-gray-700 dark:text-gray-200 disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:text-gray-400"
            />
          </div>
          <div className="md:col-span-2 flex flex-col gap-1">
            <label className="text-xs text-gray-500 dark:text-gray-400">Timezone</label>
            <div
              className={
                startMode !== "later" ? "pointer-events-none opacity-60" : ""
              }
            >
              <TimezoneSelect
                selectedTimezone={scheduledTimezone}
                setSelectedTimezone={setScheduledTimezone}
              />
            </div>
          </div>
        </div>

        {domainAuthenticationIssue && (
          <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50 p-3">
            <div className="flex items-start gap-2">
              <AlertTriangle size={17} className="mt-0.5 shrink-0 text-amber-700" />
              <div>
                <p className="text-xs font-semibold text-amber-900">Company domain authentication is incomplete</p>
                <p className="mt-1 text-xs text-amber-800">{domainAuthenticationIssue.message}</p>
              </div>
            </div>
          </div>
        )}

        <div className="flex items-center justify-end gap-2 pt-3">
          <SecondaryButton
            title="Cancel"
            onClick={() => setShowStartOptionsModal(false)}
            textColor="light"
            className="shadow-none"
          />
          {domainAuthenticationIssue ? (
            <>
              <SecondaryButton
                title="Complete Domain Setup"
                onClick={onCompleteDomainSetup}
                textColor="light"
              />
            </>
          ) : (
            <PrimaryButton
              onClick={() => handleConfirmStartCampaign()}
              startContent={false}
              disabled={isLoadingReadiness}
            >
              {startMode === "later" ? "Schedule Campaign" : "Start Campaign"}
            </PrimaryButton>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default campaignStartConfirmationModal;
